import React, { useEffect, useState, useContext } from "react";

import BackArrowIcon from '../../../../../../../assets/images/researcher_app/create/back_arrow.png';
import WhiteBackArrowIcon from '../../../../../../../assets/images/researcher_app/create/create_left_arrow_back.png';





function BackButton(props) {
    return (
        <div className="back-button-container" onClick={props.onClick}>
            <img src={WhiteBackArrowIcon} height={18} width={18} />
            <div className="back-button gray-text">
                Back
            </div>
        </div>
    )
}

export default BackButton;